export const CONNECTIONS_SETTNGS_HEAD_COPY_ID = 'Connections';

// Connections Settings Items

// Ex List Setting Item
export const EX_LIST_WITH_MUTUAL_FRIENDS_BOTTOM_SUBTITLE_ID =
  'Select and block specific people from your contact list you don’t want to see or be seen by. This works with Friends of Friends.';

// Friends of Friends Setting Item
export const MUTUAL_FRIENDS_BOTTOM_SUBTITLE_ID =
  'See if you and your potential matches share mutual contacts.';
export const MUTUAL_FRIENDS_MENU_ITEM_STATUS_DISABLED_ID = 'Disabled';
export const MUTUAL_FRIENDS_MENU_ITEM_STATUS_ENABLED_ID = 'Enabled';
export const MUTUAL_FRIENDS_MENU_ITEM_TITLE_ID = 'Friends of Friends';
